import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Button from "../components/ui/Button";
import logotype from "/images/logotype.svg";
import logotype_white from "/images/logotype-white.svg";
import cart from "/icons/cart.svg";
import cart_white from "/icons/cart-white.svg";
import "./Header.scss";
import { toggleCart } from "../store/cartSlice";
import CartOverlay from "../components/cart/CartOverlay";
import { PreservedLink as Link } from "../components/ui/PreservedLink";
import MobileMenuOverlay from "./MobileMenuOverlay";
import Hamburger from 'hamburger-react';
import { useLocation } from "react-router";
import { useAffiliate } from "../hooks/useAffiliate";
import { useIsPartnerAffiliate } from "../hooks/useIsPartnerAffiliate";
import { useAppNavigate } from "../hooks/useAppNavigate";
import { trackCTA } from "../utils/trackCTA";

function Header({ mobileMenuOpened, setMobileMenuOpened, isMobile }) {
  const dispatch = useDispatch();
  const navigate = useAppNavigate();
  const location = useLocation();
  const { affiliate, isLoading } = useAffiliate();
  const showHeaderDecoration = location.pathname === '/subscriptions';
  const whiteBgHeader = location.pathname === '/become-partner';
  const isPartnerAffiliate = useIsPartnerAffiliate();
  const colorMode = useSelector((state) => state.ui.colorMode);
  const cartOpen = useSelector((state) => state.cart.cartOpen);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const cartItemCount = cartItems.reduce((total, item) => total + item.quantity, 0);


  return (
    <header className={`${showHeaderDecoration ? 'decorated-header' : ''} ${whiteBgHeader ? 'white-bg-header' : ''}`}>
      <div className="header-container full-width">
        <div className="header-container-inner contained-width">

          {isMobile &&
            <Hamburger toggled={mobileMenuOpened} toggle={setMobileMenuOpened} size={25} />
          }

          <div className="header-logo">
            <Link to="/" onClick={() => setMobileMenuOpened(false)}>
              <img src={colorMode === 'dark' ? logotype_white : logotype} alt="Treatink" />
            </Link>
          </div>

          <div className="header-menu">
            {(!isLoading && !isPartnerAffiliate) &&
              <Link to="/#benefits" >Benefits</Link>
            }
            <Link to="/#how-it-works" >How it Works</Link>
          </div>

          <div className="header-btns">
            <Button type="button" variant="filled" className='text-sm md:text-base hideMobile'
              onClick={() => {
                navigate("/customizer");
                trackCTA('Start Personalizing');
              }}
            >
              Start Personalizing
            </Button>
            <div className="cart-btn-container">
              <Button
                type="button"
                onClick={() => {
                  setMobileMenuOpened(false);
                  dispatch(toggleCart())
                }} variant="icon"
              >
                <img src={colorMode === 'dark' ? cart_white : cart} alt="" />
                {cartItemCount > 0 && (
                  <span className="cart-count">{cartItemCount}</span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <CartOverlay isOpen={cartOpen} isMobile={isMobile} />
      <MobileMenuOverlay isOpen={mobileMenuOpened} onClose={() => setMobileMenuOpened(false)} isMobile={isMobile} />

    </header>
  );
}

Header.propTypes = {
  mobileMenuOpened: PropTypes.bool.isRequired,
  setMobileMenuOpened: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export default Header;
